export default {
  conf: '/v3/orderPrefer/conf',
  set: '/v3/orderPrefer/set',
  usePropSettingTips: '/prop/client/usePropSettingTips'
}
